module.exports = "/_next/static/images/d0a1685d1fad112a8f579750cf685c68-hick@2x.png.webp";